import { render } from "./Nav.vue?vue&type=template&id=4f21db00&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=4f21db00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f21db00"

export default script